<div class="toggler" [ngClass]="{ 'toggler--checked': checked == true, 'toggler--disabled': disabled == true, 'toggler--pending': loading == true }">
  <label class="toggler__wrapper" [attr.for]="id || name">
    <ng-container *ngTemplateOutlet="labelPosition === 'before' ? togglerText : ''"></ng-container>
    <span class="toggler__input-wrapper">
      <input
        type="checkbox"
        class="toggler__input"
        [checked]="checked === true"
        [disabled]="disabled === true"
        [attr.aria-disabled]="disabled === true"
        [attr.aria-checked]="checked === true"
        [id]="id || name"
        (click)="onChange()"
        [name]="name"
        [attr.required]="required === true"
      />
      <span *ngIf="loading" class="toggler__spinner">
        <svg class="spinner" width="14px" height="14px" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="2" stroke-linecap="round" cx="7" cy="7" r="5"></circle>
        </svg>
      </span>

    </span>
    <ng-container *ngTemplateOutlet="labelPosition == 'after' ? togglerText : ''"></ng-container>
    <ng-container *ngTemplateOutlet="text && !labelPosition ? togglerText : ''"></ng-container>
  </label>
</div>

<ng-template #togglerText>
  <span class="toggler__text">{{ text }}</span>
</ng-template>
